export default "__VITE_ASSET__yuoQuTzd__"